import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Logomark } from 'assets/images/logos/Logomark.svg';
import { useTheme } from 'contexts/ThemeContext';

interface EmptyAccountsStateProps {
  onManageAccount: () => void;
}

const EmptyAccountsState: React.FC<EmptyAccountsStateProps> = ({ onManageAccount }) => {
  const { t } = useTranslation();
  const { isDark } = useTheme();

  return (
    <div className="flex flex-col justify-center items-center gap-6 max-w-[480px] w-full">
      {/* Logomark */}
      <Logomark className="w-20 h-20" />

      {/* Title + Description */}
      <div className="flex flex-col items-center gap-4 w-full">
        <h2
          className="text-2xl font-bold leading-8 text-center w-full"
          style={{ color: isDark ? '#E2E8F0' : '#314158' }}
        >
          {t('accounts.emptyState.title') || "You're one step away from real growth"}
        </h2>
        <p
          className="text-base font-normal leading-6 text-center w-full"
          style={{ color: isDark ? '#E2E8F0' : '#314158' }}
        >
          {t('accounts.emptyState.description') || 'Connect an Instagram account to unlock automations, audience targeting, and live growth analytics'}
        </p>
      </div>

      {/* Gradient Button */}
      <button
        onClick={onManageAccount}
        className="w-full text-white text-base font-medium transition-opacity hover:opacity-90"
        style={{
          background: 'linear-gradient(90deg, #2B7FFF 0%, #AD46FF 100%)',
          borderRadius: '12px',
          padding: '12px 16px',
          height: '48px',
        }}
      >
        {t('accounts.emptyState.connectButton') || 'Connect an Instagram account'}
      </button>
    </div>
  );
};

export default EmptyAccountsState;
